import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"
import FieldProto_updateView from "../../../../../proto/render/table/function/update-view"

export default function FieldTimeReportMessage_TableCell(props: FieldTableCellProps): React.ReactElement {
    const timeReport = props.listItem.timeReport

    const onChange = async (value: string | null) => {
        if (timeReport && props.field.fieldId in timeReport) {
            // @-ts-expect-error: Dynamic field assignment, field type not known at compile time
            timeReport[props.field.fieldId] = value ?? ''
        }

        await timeReport.saveUniversal()
        props.listItem.updateLastUpdateTime()
        FieldProto_updateView(props.manager, props.field)
    }

    return (
        <div className  = "cell-flex p-0"
             style      = {getTableCellStyle(props)}
        >
            <props.field.renderComponents.editable
                className       = "w-100-percent h-100-percent"
                textClassName   = "ui5-txt-less-important-small"
                disabled        = {props.manager.isReadOnly}
                field           = {props.field}
                model           = {timeReport}
                onChange        = {onChange}
            />
        </div>
    )
}
